import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TSelectOption } from 'src/app/project/components/input/select/select.model';
import { EPointSearchOperator } from 'src/app/project/modules/points/point-search/point-search.consts';
import { TTagSelectOptions } from 'src/app/project/modules/tags/tag-select/tag-select.component';
import { EAdvancedFilterOptions } from '../../../../models/advanced-filter-options.enum';
import {
  TAdvancedFilterSingle,
  TAdvancedFilterTag,
  TFilterTagOptions,
} from '../../../../models/advanced-filter.model';
import { tagExtendedOperatorOptions } from '../../../../utils/advanced-filter-operator.utils';

@Component({
  selector: 'pp-advanced-filter-tag',
  templateUrl: './advanced-filter-tag.component.html',
  styleUrls: ['./advanced-filter-tag.component.scss'],
  standalone: false,
})
export class AdvancedFilterTagComponent {
  @Input() ppFilter: TAdvancedFilterSingle;
  @Input() ppWorkspaceId: string;
  @Output() ppFilterChange = new EventEmitter<TAdvancedFilterSingle>();

  value: string[] = [];
  option: TFilterTagOptions;
  filter: TAdvancedFilterTag;
  tagSelectOptions: TTagSelectOptions;

  advancedFilterTagOptions: TSelectOption[];

  EAdvancedFilterOptions = EAdvancedFilterOptions;

  ngOnChanges(): void {
    this.advancedFilterTagOptions = tagExtendedOperatorOptions;

    this.filter = this.ppFilter as TAdvancedFilterTag;

    this.value = this.filter.value ? this.filter.value : [];
    this.option = this.filter.option;

    this.setTagSelectOptions();
  }

  private setTagSelectOptions(): void {
    this.tagSelectOptions = {
      showIcon: false,
      noTagRemovedDebounceTime: true,
      singleLineInput: true,
      singleSelectOnly:
        this.option === EAdvancedFilterOptions.IS || this.option === EAdvancedFilterOptions.IS_NOT,
    };
  }

  changeFieldCondition(newCondition: TSelectOption): void {
    const value = newCondition.value as TFilterTagOptions;
    if (
      (value === EAdvancedFilterOptions.IS || value === EAdvancedFilterOptions.IS_NOT) &&
      this.filter?.value?.length
    ) {
      this.filter.value = [this.filter.value[0]]; // New array to trigger ngOnChanges
      this.value = this.filter.value;
    }

    this.ppFilter.operator = newCondition.operator;

    if (
      newCondition.operator === EPointSearchOperator.IN ||
      newCondition.operator === EPointSearchOperator.NOT_IN
    ) {
      this.ppFilter.value = newCondition.data;
    }

    this.ppFilter.option = value;
    this.option = value;

    this.setTagSelectOptions();
    this.applyChanges();
  }

  applyChanges(): void {
    this.ppFilterChange.emit(this.ppFilter);
  }

  changeFieldValue(value: string[]): void {
    this.value = value;
    this.ppFilter.value = value;
    this.applyChanges();
  }
}
